import React from 'react';

const Neutral = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#3498DB"/>
      <path d="M15 6.875C14.7119 6.875 14.4141 6.89209 14.0918 6.92871L14.2285 8.16895C14.5068
      8.13965 14.7583 8.125 15 8.125C18.7915 8.125 21.875 11.2085 21.875 15C21.875 18.7915
      18.7915 21.875 15 21.875C14.7583 21.875 14.5093 21.8604 14.2358 21.8286L14.0967
      23.0713C14.4165 23.1079 14.7119 23.125 15 23.125C19.48 23.125 23.125 19.48 23.125
      15C23.125 10.52 19.48 6.875 15 6.875ZM12.3169 7.33643C11.7432 7.53662 11.1938 7.80518
      10.6787 8.12744L11.3452 9.18457C11.7798 8.91113 12.2461 8.68652 12.7319 8.51562L12.3169
      7.33643ZM9.25293 9.25537C8.84033 9.67041 8.45947 10.1514 8.125 10.6836L9.18457
      11.3477C9.46777 10.8936 9.79004 10.4883 10.1367 10.1392L9.25293 9.25537ZM7.33398
      12.3218C7.13135 12.9077 6.99463 13.5034 6.92871 14.0942L8.16895 14.231C8.2251
      13.7354 8.34228 13.23 8.51562 12.7344L7.33398 12.3218ZM8.17139 15.7715L6.92871
      15.9106C6.99707 16.5039 7.13379 17.0996 7.33887 17.6855L8.51807 17.2705C8.34473
      16.7749 8.22754 16.272 8.17139 15.7715ZM9.18457 18.6572L8.12988 19.3237C8.46436 19.8535
      8.84277 20.3345 9.25781 20.7495L10.1416 19.8633C9.79248 19.5142 9.47021 19.1089 9.18457
      18.6572ZM11.3501 20.8203L10.6836 21.875C11.1987 22.1997 11.748 22.4634 12.3242 22.666L12.7344
      21.4844C12.2485 21.3159 11.7822 21.0913 11.3501 20.8203Z" fill="white"/>
    </svg>

  );
};

export default Neutral;
